/**
 * Centralized ad configuration
 *
 * This file contains:
 * - Paths where ads are displayed
 * - Kill switch configuration for transitioning between ad providers
 */

import {
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_GAM,
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
} from "../redux/siteData";

/**
 * Pages/paths where ads are displayed
 * Update this array when adding/removing ad locations
 */
export const AD_PATHS = ["/lobby", "/players", "/game", "/daily/game"] as const;

/**
 * Check if a path should show ads
 */
export function shouldLoadAdsForPath(path: string): boolean {
  return AD_PATHS.some((adPath) => path.includes(adPath));
}

/**
 * Ad provider configuration
 *
 * Environment variables (set in .env.local or deployment):
 * - NEXT_PUBLIC_ADS_PROVIDER: "playwire" | "diy" | "yandex" (default: "playwire")
 * - NEXT_PUBLIC_ADS_ROLLOUT: 0-100 (percentage of traffic to use DIY, default: 0)
 * - NEXT_PUBLIC_ADS_FORCE_PROVIDER_FOR_IPS: comma-separated IPs (e.g., "1.2.3.4,5.6.7.8")
 */
export type AdProvider =
  | typeof ADS_PROVIDER_PLAYWIRE
  | typeof ADS_PROVIDER_GAM
  | typeof ADS_PROVIDER_YANDEX
  | typeof ADS_PROVIDER_ADSENSE;

export interface AdConfig {
  provider: AdProvider;
  // rollout: number; // 0-100, percentage to use DIY instead of Playwire
  // forceProviderForIPs?: string[]; // IPs that should use forced provider
}

/**
 * Get user's IP address (client-side only, may not be accurate)
 * Note: This is a placeholder. For production, you may want to:
 * 1. Fetch IP from your backend API
 * 2. Use a service like ipify.org
 * 3. Get IP from request headers (server-side only)
 */
function getUserIP(): string | null {
  if (typeof window === "undefined") return null;
  // Placeholder - implement IP fetching logic here if needed
  // Example: fetch from API endpoint that returns user IP
  return null;
}

/**
 * Get ad configuration with kill switch logic
 */
export function getAdConfig(): AdConfig {
  const envProvider = (process.env.NEXT_PUBLIC_ADS_PROVIDER ||
    ADS_PROVIDER_PLAYWIRE) as AdProvider;

  // const envRollout = parseInt(process.env.NEXT_PUBLIC_ADS_ROLLOUT || "0", 10);
  // const forceIPs = process.env.NEXT_PUBLIC_ADS_FORCE_PROVIDER_FOR_IPS
  //   ? process.env.NEXT_PUBLIC_ADS_FORCE_PROVIDER_FOR_IPS.split(",").map((ip) =>
  //       ip.trim()
  //     )
  //   : undefined;

  // If provider is explicitly set to "diy" or "yandex", use it directly
  if (
    envProvider === ADS_PROVIDER_GAM ||
    envProvider === ADS_PROVIDER_YANDEX ||
    envProvider === ADS_PROVIDER_ADSENSE ||
    envProvider === ADS_PROVIDER_PLAYWIRE
  ) {
    return {
      provider: envProvider,
      // rollout: 0,
      // forceProviderForIPs: forceIPs,
    };
  }

  // // For "playwire" provider, check rollout percentage
  // // Rollout determines what percentage gets DIY instead of Playwire
  // const shouldUseGam = Math.random() * 100 < envRollout;

  // // Check IP override
  // const userIP = getUserIP();
  // if (userIP && forceIPs?.includes(userIP)) {
  //   // If IP is in force list, use the forced provider (you may want to add logic here)
  //   // For now, we'll use the rollout logic
  // }

  // return {
  //   provider: shouldUseGam ? ADS_PROVIDER_GAM : ADS_PROVIDER_PLAYWIRE,
  //   rollout: envRollout,
  //   forceProviderForIPs: forceIPs,
  // };
}
